import { Component, ViewEncapsulation } from '@angular/core';

// This component purpose is to encapsulate as Shadow DOM all it's content
@Component({
  selector: 'app-shadow-dom-encapsulate',
  template: '<ng-content></ng-content>',
  encapsulation: ViewEncapsulation.ShadowDom,
    standalone: false
})
export class ShadowDomEncapsulateComponent {
  constructor() { }
}
